import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { CitizensServicesResult } from './citizens-services-result.model';

export const loadCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Load CitizensServicesResults', 
  props<{ citizensServicesResults: CitizensServicesResult[] }>()
);

export const addCitizensServicesResult = createAction(
  '[CitizensServicesResult/API] Add CitizensServicesResult',
  props<{ citizensServicesResult: CitizensServicesResult }>()
);

export const upsertCitizensServicesResult = createAction(
  '[CitizensServicesResult/API] Upsert CitizensServicesResult',
  props<{ citizensServicesResult: CitizensServicesResult }>()
);

export const addCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Add CitizensServicesResults',
  props<{ citizensServicesResults: CitizensServicesResult[] }>()
);

export const upsertCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Upsert CitizensServicesResults',
  props<{ citizensServicesResults: CitizensServicesResult[] }>()
);

export const updateCitizensServicesResult = createAction(
  '[CitizensServicesResult/API] Update CitizensServicesResult',
  props<{ citizensServicesResult: Update<CitizensServicesResult> }>()
);

export const updateCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Update CitizensServicesResults',
  props<{ citizensServicesResults: Update<CitizensServicesResult>[] }>()
);

export const deleteCitizensServicesResult = createAction(
  '[CitizensServicesResult/API] Delete CitizensServicesResult',
  props<{ id: string }>()
);

export const deleteCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Delete CitizensServicesResults',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesResults = createAction(
  '[CitizensServicesResult/API] Clear CitizensServicesResults'
);

export const citizenGetServicesResults = createAction(
  '[CitizensServicesResult/API] citizen Get Services Results',
  props<{ serviceUniqueId: string}>()
);
